import React from "react";
import './App.css';
import Scorepad from './Components/Scorepad/Scorepad';

function App() {
  return (
    <div className="app">
      <Scorepad />
    </div>
  );
}

export default App;
